import { useContextStore } from 'src/store'
import type { IsoLanguage } from 'src/types/language'
import { type Pinia } from 'pinia'
import piniaGlobal from 'src/configs/piniaGlobal'

// TODO: Доработать, чтобы разделить использования для vue-ssr и чисто клиентского рендера
function getUserLanguage(pinia?: Pinia): IsoLanguage {
  const { context } = useContextStore(pinia || piniaGlobal)
  let iso = context?.current_language?.iso

  if (typeof window !== 'undefined') {
    iso = window.LANGUAGE_DATA?.currentLanguage.iso
  }

  return iso || 'ru' as const
}

export default getUserLanguage
